/* Ascendia product page, round 4 - 7 Oct 2026 (tools/pdp-round4-7oct2026/REPORT.md). Never throws.
   "In leggings you usually wear: S / M / L" - one tap that refines OUR ESTIMATE (height + weight, assets/asc-size-guide.js) on a
   piece with no maker size chart. Only switched on where snippets/asc-pdp-r4.liquid prints window.ASC_R4.
   The engine is never edited: this reads its answer (the <b> in "Suggested size: S" and the Choose button) after each render
   and, when her usual size changes the advice, rewrites that answer + the Choose button. Round 3 (asc-pdp-r3.js) then presses
   the button exactly as before, so ADD TO CART unlocks the same way. Numbers are only the ones she typed. */
(function () {
  'use strict';
  var C = window.ASC_R4;
  if (!C || !C.on || window.__ascR4) return; window.__ascR4 = 1;
  var d = document, ar = !!C.ar;
  var LADDER = ['XS', 'S', 'M', 'L', 'XL'];
  var SZ = (C.sizes && C.sizes.length ? C.sizes : ['S', 'M', 'L']).filter(function (s) { return LADDER.indexOf(s) >= 0; });
  var KEY = 'asc-r4-usual-leggings';
  var b = function (s) { return '<bdi dir="ltr"><b>' + s + '</b></bdi>'; };
  var T = ar ? {
    q: 'مقاسك المعتاد في الليقنز',
    same: 'مقاسك المعتاد %U يطابق تقديرنا.',
    up: 'تقديرنا من الطول والوزن هو %E، ومقاسك المعتاد في الليقنز %U. والتجربة الفعلية أدق من أي تقدير، لذلك نقترح %U، وسيكون أريح قليلاً من %E.',
    dn: 'تقديرنا من الطول والوزن هو %E، ومقاسك المعتاد في الليقنز %U. والتجربة الفعلية أدق من أي تقدير، لذلك نقترح %U، وسيكون أكثر التصاقاً قليلاً من %E.',
    gap: 'تقديرنا من الطول والوزن هو %E، ومقاسك المعتاد %U. الفرق كبير، لذلك نقترح المقاس الأوسط %M. وفريقنا يساعد على واتساب إن لم يكن الأمر واضحاً.',
    hipSame: 'يطابق مقاسك المعتاد %U.',
    hipDiff: 'مقاسك المعتاد %U، لكن قياس الورك يشير إلى %E، والقياس بالشريط أدق.',
    only: 'تم اختيار %U، مقاسك المعتاد. والطول والوزن في الأعلى يؤكدان المقاس.',
    onlyNo: 'مقاسك المعتاد %U. والطول والوزن في الأعلى يؤكدان المقاس.',
    sold: 'مقاسك المعتاد %U غير متوفر بهذا اللون حالياً.',
    wa: 'مساعدة في المقاس من فريقنا عبر واتساب',
    msg: 'مساعدة في مقاس %P:', h: 'الطول %N سم', w: 'الوزن %N كغ', u: 'مقاسي المعتاد %N'
  } : {
    q: 'Usual size in leggings',
    same: 'Your usual %U matches our estimate.',
    up: 'Our estimate from height and weight is %E. You usually wear %U in leggings, and what you already wear beats any estimate, so we suggest %U. It will sit a little easier than %E.',
    dn: 'Our estimate from height and weight is %E. You usually wear %U in leggings, and what you already wear beats any estimate, so we suggest %U. It will sit a little closer than %E.',
    gap: 'Our estimate from height and weight is %E, but you usually wear %U. That is a big gap, so we suggest the size in between: %M. Our team can help on WhatsApp.',
    hipSame: 'It matches your usual %U.',
    hipDiff: 'You usually wear %U, but your hip measurement points to %E, and a tape is the surer guide.',
    only: '%U selected, your usual size. To double-check, add your height and weight above.',
    onlyNo: 'Your usual size is %U. To double-check, add your height and weight above.',
    sold: 'Your usual %U is sold out in this colour right now.',
    wa: 'Size help from our team on WhatsApp',
    msg: '%P size help:', h: '%N cm', w: '%N kg', u: 'usual %N'
  };
  function put(s, m) { return s.replace(/%([UEM])/g, function (_, k) { return m[k] ? b(m[k]) : ''; }); }
  function sec() { return d.querySelector('section[id^="MainProduct-"]'); }
  function radio(s) {
    var S = sec(); if (!S) return null;
    var l = S.querySelectorAll('variant-radios input[type="radio"], variant-selects input[type="radio"]');
    for (var i = 0; i < l.length; i++) if (l[i].value === s && l[i].closest('.asc-size-fs, fieldset')) {
      var fs = l[i].closest('fieldset'); if (fs && fs.querySelector('input[value="' + SZ[0] + '"]')) return l[i];
    }
    return null;
  }
  function buyable(s) { var r = radio(s); return !!r && !r.disabled && !r.classList.contains('disabled'); }
  function pickByHand(s) {
    var r = radio(s); if (!r || r.checked) return;
    var lab = r.id ? d.querySelector('label[for="' + r.id + '"]') : null;
    (lab || r).click();
  }
  function num(v) { v = parseFloat(String(v || '').replace(',', '.')); return isFinite(v) && v > 0 ? v : NaN; }
  function vis(x) { return x && x.offsetParent !== null; }

  function boot() {
    var wrap = d.querySelector('details[data-asc-sg-quickwrap]');
    var form = wrap && wrap.querySelector('[data-asc-sg-form]');
    if (!form) return;
    var fields = form.querySelector('.asc-sg__fields');
    var res = form.querySelector('[data-asc-sg-result]');
    var ans = form.querySelector('[data-asc-sg-answer]');
    var why = form.querySelector('[data-asc-sg-why]');
    var btn = form.querySelector('[data-asc-sg-choose]');
    if (!fields || !res || !ans || !why || !btn) return;
    var usual = null;
    try { var m0 = localStorage.getItem(KEY); if (SZ.indexOf(m0) >= 0) usual = m0; } catch (e) { /* private mode */ }

    /* --- the row --- */
    var row = d.createElement('div');
    row.className = 'asc-r4-usual'; row.setAttribute('role', 'group'); row.setAttribute('aria-labelledby', 'AscR4Q');
    row.innerHTML = '<span class="asc-r4-usual__t" id="AscR4Q">' + T.q + '</span><span class="asc-r4-usual__o">' +
      SZ.map(function (s) { return '<button type="button" data-u="' + s + '" aria-pressed="false">' + s + '</button>'; }).join('') + '</span>';
    fields.parentNode.insertBefore(row, fields.nextSibling);
    var only = d.createElement('p'); only.className = 'asc-r4-only'; only.hidden = true; only.setAttribute('aria-live', 'polite');
    row.parentNode.insertBefore(only, row.nextSibling);
    var note = d.createElement('p'); note.className = 'asc-r4-note'; note.hidden = true;
    why.parentNode.insertBefore(note, why.nextSibling);
    var wa = d.createElement('a'); wa.className = 'asc-r4-wa'; wa.target = '_blank'; wa.rel = 'noopener'; wa.hidden = true;
    wa.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.4.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.2 5.1 5.1 0 0 0 1.1 2.7 11.6 11.6 0 0 0 4.4 3.9c1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.7-.6Z"/></svg><span>' + T.wa + '</span>';
    var xc = wrap.querySelector('.asc-xchg');
    (xc ? xc.parentNode : form.parentNode).insertBefore(wa, xc ? xc.nextSibling : null);

    /* --- the engine's own answer, kept from its last render --- */
    var eng = null, mine = false;
    function snap() {
      var bb = ans.querySelector('b');
      eng = {
        shown: !res.hidden, tight: res.classList.contains('is-tight'),
        size: bb ? bb.textContent.trim() : null,
        ansH: ans.innerHTML, whyH: why.innerHTML, whyHid: why.hidden,
        btnS: btn.getAttribute('data-size'), btnT: btn.classList.contains('asc-r3-done') && btn.__r3t ? btn.__r3t : btn.textContent, btnHid: btn.hidden
      };
      mine = false;
    }
    function restore() {
      if (!mine || !eng) return;
      ans.innerHTML = eng.ansH; why.innerHTML = eng.whyH; why.hidden = eng.whyHid;
      if (eng.btnS) btn.setAttribute('data-size', eng.btnS);
      btn.textContent = eng.btnT; btn.hidden = eng.btnHid; btn.__r3t = eng.btnT;
      mine = false;
    }
    function vals() {
      var g = function (n) { var x = form.querySelector('input[name="' + n + '"]'); return x && vis(x) ? num(x.value) : NaN; };
      var h = g('h'); if (!isFinite(h)) { var ft = g('h_ft'), inch = g('h_in') || 0; if (isFinite(ft)) h = Math.round((ft * 12 + (isFinite(inch) ? inch : 0)) * 2.54); }
      var w = g('w'); if (!isFinite(w)) { var lb = g('w_lb'); if (isFinite(lb)) w = Math.round(lb * 0.4536); else { var st = g('w_st'), sl = g('w_sl'); if (isFinite(st)) w = Math.round((st * 14 + (isFinite(sl) ? sl : 0)) * 0.4536); } }
      return { h: h >= 120 && h <= 230 ? Math.round(h) : NaN, w: w >= 30 && w <= 250 ? Math.round(w) : NaN, hip: g('hip') };
    }
    function waLink() {
      var v = vals(), parts = [];
      if (isFinite(v.h)) parts.push(T.h.replace('%N', v.h));
      if (isFinite(v.w)) parts.push(T.w.replace('%N', v.w));
      if (usual) parts.push(T.u.replace('%N', usual));
      if (!parts.length) { wa.hidden = true; return; }
      wa.href = 'https://wa.me/' + C.wa + '?text=' + encodeURIComponent(T.msg.replace('%P', C.name) + ' ' + parts.join(ar ? '، ' : ' '));
      wa.hidden = false;
    }
    function setChoose(s) {
      var t = (eng && eng.btnT) || btn.textContent;
      var from = eng && eng.btnS;
      var txt = from ? t.replace(new RegExp('(^|\\s)' + from + '(?=\\s|$)'), '$1' + s) : t;
      btn.classList.remove('asc-r3-done'); btn.removeAttribute('aria-pressed');
      btn.setAttribute('data-size', s); btn.textContent = txt; btn.__r3t = txt; btn.hidden = false;
      /* that size is already the chosen one: show it as chosen, the way round 3 does after a pick */
      var r = radio(s), S = sec();
      if (r && r.checked && S && !S.classList.contains('asc-nosize-sec')) {
        btn.classList.add('asc-r3-done'); btn.setAttribute('aria-pressed', 'true');
        btn.textContent = (ar ? 'تم اختيار المقاس %S' : '%S selected').replace('%S', s);
      }
    }
    /* only a real engine render counts: it rewrites the answer line, which drops our marked <b>. Round 3 ticking the
       Choose button ("M selected") is not a new answer. */
    var mo = new MutationObserver(function () { if (mine && ans.querySelector('b.asc-r4-b')) return; snap(); apply(false); });
    function watch(on) { if (on) mo.observe(res, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class', 'data-size'] }); else mo.disconnect(); }

    function apply(tapped) {
      watch(false);
      try {
        row.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-u') === usual)); });
        restore();
        note.hidden = true; note.innerHTML = '';
        var shown = !res.hidden && eng && eng.shown;
        only.hidden = true;
        if (!usual) return;
        if (!shown) {
          /* no numbers yet: her usual size is her own choice - a tap chooses it (when it can be bought) */
          if (!buyable(usual)) { only.innerHTML = put(T.sold, { U: usual }); only.hidden = false; return; }
          if (tapped) pickByHand(usual);
          var r = radio(usual);
          only.innerHTML = put(r && r.checked ? T.only : T.onlyNo, { U: usual }); only.hidden = false;
          return;
        }
        var E = eng.size;
        if (eng.tight || !E || SZ.indexOf(E) < 0) return;      /* "may be too small" etc.: the engine's honest answer stands */
        var v = vals(), ui = SZ.indexOf(usual), ei = SZ.indexOf(E), diff = ui - ei;
        var keep = function (line) { note.innerHTML = line; note.hidden = false; if (tapped && !btn.hidden) { var c = radio(btn.getAttribute('data-size')); if (c && !c.checked) btn.click(); } };
        if (isFinite(v.hip)) { keep(put(diff === 0 ? T.hipSame : T.hipDiff, { U: usual, E: E })); return; }
        if (diff === 0) { keep(put(T.same, { U: usual })); return; }
        var fin = Math.abs(diff) === 1 ? usual : SZ[Math.min(ui, ei) + 1];
        if (!buyable(fin)) { note.innerHTML = put(T.sold, { U: fin }); note.hidden = false; return; }
        var bb = ans.querySelector('b');
        if (bb) { bb.textContent = fin; bb.className = 'asc-r4-b'; }
        why.innerHTML = put(Math.abs(diff) === 1 ? (diff > 0 ? T.up : T.dn) : T.gap, { U: usual, E: E, M: fin });
        why.hidden = false;
        setChoose(fin);
        mine = true;
        /* a tap on her usual size after a size was already chosen from the numbers: choose the new advice too */
        if (tapped) { var cur = radio(fin); if (cur && !cur.checked) btn.click(); }
      } finally { waLink(); mo.takeRecords(); watch(true); }
    }

    row.addEventListener('click', function (e) {
      var x = e.target.closest && e.target.closest('button[data-u]');
      if (!x) return;
      var s = x.getAttribute('data-u');
      usual = usual === s ? null : s;                       /* a second tap clears it */
      try { if (usual) localStorage.setItem(KEY, usual); else localStorage.removeItem(KEY); } catch (err) { /* private mode */ }
      apply(true);
    });
    form.addEventListener('input', function () { setTimeout(waLink, 0); });
    snap(); apply(false);
  }
  function go() { try { boot(); } catch (e) { /* never break the page */ } }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', go); else go();
})();
